// src/shared/components/ui/checkbox.tsx

import { Check } from 'lucide-react'
import type { InputHTMLAttributes } from 'react'

import { cn } from '@/shared/utils/cn'

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: string
}

export function Checkbox({ className, checked, label, disabled, ...props }: CheckboxProps) {
  return (
    <label
      className={cn(
        'inline-flex cursor-pointer items-center gap-2',
        disabled && 'cursor-not-allowed opacity-50',
        className,
      )}
    >
      <span className="relative inline-flex h-4 w-4">
        <input
          checked={checked}
          className="peer sr-only"
          disabled={disabled}
          type="checkbox"
          {...props}
        />
        <span
          className={cn(
            'h-4 w-4 rounded-sm border transition',
            'border-[var(--panel-border-strong)] bg-[var(--panel)]',
            'peer-checked:border-[var(--color-brand)] peer-checked:bg-[var(--color-brand)]',
            'peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--color-brand)] peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-[var(--app-bg)]',
          )}
        />
        {checked ? (
          <Check
            className="absolute left-0 top-0 h-4 w-4 text-[var(--color-brand-fg)]"
            strokeWidth={3}
          />
        ) : null}
      </span>
      {label ? <span className="text-sm text-[var(--color-text)]">{label}</span> : null}
    </label>
  )
}
